import { Component } from 'react'
import { connect } from 'react-redux'
import { timezoneDate } from 'utils/helpers'
import { MY_TASKS_FETCH_REQ } from 'components/Dashboard/actions'
import cn from 'classnames'
import ComponentFrame from 'components/Dashboard/ComponentFrame/ComponentFrame'
import s from './MyTasks.scss'
import TaskIcons from './TaskIcons'
import { ScheduleTaskModal } from 'components/common/modals/ScheduleTaskModal'
import * as ACT from './actions'
import { fromUsers } from 'utils/serializers'
import { getUser } from 'utils/authService'

@connect(({ dashboard, users, deal }, ownProps) => {
  return {
    dashboard,
    users,
    deal,
    filterUserId: ownProps.userId
  }
})
class MyTasksContainer extends Component {
  state = {
    showScheduleTaskModal: false,
    task: {}
  }

  componentDidMount() {
    this.updateMyTasks()
  }

  updateMyTasks = () => {
    const { userId } = this.props
    setTimeout(
      () =>
        this.props.dispatch({
          type: MY_TASKS_FETCH_REQ,
          payload: {
            userId: userId ? (userId !== 'allUsers' ? userId : '') : getUser().id
          }
        }),
      500
    )
  }

  toggleScheduleTaskModal = task => {
    if (task) {
      this.setState({ task }, () => {
        this.setState(prevState => ({
          showScheduleTaskModal: !prevState.showScheduleTaskModal
        }))
      })
    } else {
      this.setState(prevState => ({
        showScheduleTaskModal: !prevState.showScheduleTaskModal
      }))
    }
    if (!this.state.showScheduleTaskModal) {
      this.props.dispatch({
        type: ACT.USERS_FETCH_REQUESTED
      })
    }
  }

  updateTask = task => {
    this.props.dispatch({
      type: ACT.UPDATE_DEAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  markTaskAsDone = id => {
    this.props.dispatch({
      type: ACT.DEAL_TASK_MARK_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  markTaskAsNotDone = id => {
    this.props.dispatch({
      type: ACT.DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  deleteTask = task => {
    this.props.dispatch({
      type: ACT.DELETE_DEAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
    this.updateMyTasks()
  }

  render() {
    const { myTasks } = this.props.dashboard
    const { users } = this.props.users
    const { showScheduleTaskModal, task } = this.state
    const taskTypes = Object.keys(myTasks).length === 0 ? [] : ['today', 'overdue', 'future']
    return (
      <>
        {showScheduleTaskModal && (
          <ScheduleTaskModal
            showScheduleTaskModal={showScheduleTaskModal}
            toggleScheduleTaskModal={this.toggleScheduleTaskModal}
            updateTask={this.updateTask}
            users={fromUsers(users)}
            edit
            selectedTask={task}
            markAsDone={this.markTaskAsDone}
            markAsNotDone={this.markTaskAsNotDone}
            deleteTask={this.deleteTask}
            onSaveTaskCb={this.updateMyTasks}
          />
        )}
        <ComponentFrame
          title="Tasks"
          subTitle="Below are tasks due today or overdue. Click to see the deal they’re linked to."
        >
          <div className={s.myTasksWrapper}>
            {taskTypes.map(elType => (
              <div key={elType}>
                {elType === 'today' && (
                  <div className={cn(s.taskTypeTitle, s.dueTodayTitle)}>Due Today</div>
                )}
                {elType === 'overdue' && (
                  <div className={cn(s.taskTypeTitle, s.lateOverdueTitle)}>Late / Overdue</div>
                )}
                {elType === 'future' && (
                  <div className={cn(s.taskTypeTitle, s.futureTitle)}>Future</div>
                )}
                {myTasks[elType].length !== 0 ? (
                  <table>
                    <tbody>
                      {myTasks[elType].map(el => {
                        const TaskIcon = TaskIcons[el.type]
                        return (
                          <tr key={el.id}>
                            <td className={s.taskIcon}>
                              <TaskIcon />
                            </td>
                            <td className={s.taskDate}>{timezoneDate(el.dueDate)}</td>
                            {el.dealName !== null ? (
                              <td
                                onClick={() => this.toggleScheduleTaskModal(el)}
                                className={s.taskLink}
                              >
                                {el.dealName}
                              </td>
                            ) : el.proposalName !== null ? (
                              <td
                                onClick={() => this.toggleScheduleTaskModal(el)}
                                className={s.taskLink}
                              >
                                {el.proposalName}
                              </td>
                            ) : (
                              ''
                            )}
                            <td className={s.taskName}>{el.subject}</td>
                            <td
                              onClick={() => this.toggleScheduleTaskModal(el)}
                              className={s.taskDetails}
                            >
                              &#187;
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className={s.noTasks}>There are no tasks</div>
                )}
              </div>
            ))}
          </div>
        </ComponentFrame>
      </>
    )
  }
}

export default MyTasksContainer
